import { Calculator } from "../common/calculator";
import { TextField } from '../common/basic_fields';
import { buildXlsx, shiftWidth, mergeCellsRight } from '@lib/utils/export/xlsx';
import { calculationBullet, UnitProp, Fraction, SquareRoot, Unit } from './math';

class NmcCalculator extends Calculator {
    code() { return "nmc"; }
    type() { return "CalcNmcc"; }

    initialize() {
        let self = this;
        this.setupStatistic({
            calcName: 'nmcc'
        });
        this.patchFieldTypes([NmccTextField]);

        this.dynamicCalculation = this.addInputField("#nmccTable", 'calculatedList', {
            dynamic: true,
            appendButtonSelector: ".addNewPosition",
            removeSelector: ".dynamic-list-row-remove a",
            keepOne: true,
            ignoreForEmpty: true,
            removeFirstEvent: () => {
                self.onResetCommon();
                $(".provider-price input").val("");
                $(".count-goods-input input").val("0");
                $(".substract-providers").hide();
                $(".dynamic-list-comment input").val("1-я позиция расчёта НМЦК");
                $(".provider-comment input").map((index, elem) =>{
                    $(elem).val(`цена источника ${index - 1}`);
                });
            },
            prepareTemplate: function ($clone, blockPiece) {
                $clone.data('rowIndex', blockPiece.index + 1);
                $clone.attr('data-rowindex', blockPiece.index + 1); 
                var $comment = $clone.find('.dynamic-list-comment > .input-icon input').keyup(function () {
                    $(this).data('changed', '1');
                    self.autoSubmit();
                }).focus(tools.selectAllText);
                $comment.val($clone.data('rowIndex') + '-я позиция расчёта НМЦК');

                $clone.find(".count-goods-input input").val(0);

                $($clone.find(".substract-providers")[0]).click((e) =>{
                    let providersDynamic = blockPiece.tree.providersData;
                    let count = providersDynamic.getElements().length;
                    providersDynamic.setCount({ count: count - 1});
                    if (count == 4) {
                        $clone.find(".substract-providers").hide();
                        $clone.find('.dynamic-list-count-goods').removeClass("with-substract");
                    }
                });

                $($clone.find(".add-providers")[0]).click(() =>{
                    let providersDynamic = blockPiece.tree.providersData;
                    let count = providersDynamic.getElements().length - 1;
                    if (count == 3) {
                        $clone.find(".substract-providers").show();
                        $clone.find('.dynamic-list-count-goods').addClass("with-substract");
                    }

                   providersDynamic.setCount({ count: count + 1});
                });

                blockPiece.tree.providersData.setCount({count: 3});
              
                return { block: $clone, artifacts : {rowIndex: blockPiece.index + 1 } }
            }, 
            fields: {
                countGoods:{
                    selector:".count-goods-input input",
                    options:  {
                        type: 'float',
                        options: { precision: 6, keyup: true },
                        defaultValue: 0,
                    },
                },
                comment: {
                    selector: ".dynamic-list-comment > .input-icon input",
                    options: {
                        type: 'nmccText',
                        defaultValue: () => '1-я позиция расчёта НМЦК'
                    },
                },
                providersData:{
                    selector:".providersTable",
                    options:{
                        dynamic: true,
                        appendButtonSelector: ".add-providers", 
                        ignoreForEmpty: true,
                        keepOne: false,
                        prepareTemplate($clone, blockPiece) {
                            $clone.data('rowIndex', blockPiece.index + 1);
                
                            var $comment = $clone.find('.provider-comment input').keyup(function () {
                                $(this).data('changed', '1');
                                self.autoSubmit();
                            }).focus(tools.selectAllText);
                            const value = 'цена источника ' + $clone.data('rowIndex');
                            $comment.val(value);
                            $comment.data("value", $clone.data('rowIndex') <= 3 ? value : null)
                            
                            return {block: $clone, artifacts : {defaultValue: value }}
                        },
                        fields: {
                            providerName: {
                                selector: ".provider-comment input",
                                options: function($clone) {
                                    return {
                                        type: 'nmccText',
                                        options: { keyup: true },
                              
                                        defaultValue: () => $clone.find('.provider-comment input').data("value")
                                    }
                                },
                            }, 
                            providerPrice: {
                                selector: ".provider-price input",
                                options: {
                                    type: 'money',
                                    options: { keyup: true },
                                    defaultValue: ""
                                },
                            },
                        }
                    }, 
                    
                }
            }
        });

        this.formulaHtmlContent = {
            nmc: new Fraction("количество товара &times; (цена источника 1 + цена источника 2 + &hellip;)", "количество источников"),
            mean: new Fraction("цена источника 1 + цена источника 2 + &hellip;", "количество источников"),
            varCoef: new Fraction("среднее квадратичное отклонение &times; 100", "средняя цена"),
            std: new SquareRoot(new Fraction("(цена источника 1 за ед. товара - средняя цена)<sup>2</sup> + &hellip;", "количество источников − 1"))
        };

        const renderDescriptionBlock = (blockInfo) => {
            const nmcBlock = {
                name: 'НМЦК',
                content: `${blockInfo.resultPriceHtml.html} = ${blockInfo.resultPrice}`,
                formula: this.formulaHtmlContent.nmc.html,
            }

            const descriptionBlocks = [
                {
                    name: 'Средняя цена',
                    content: {
                        firstAction : `${blockInfo.elementsSumHtml} = ${blockInfo.sum}`,
                        secondAction : blockInfo.mean
                    },
                    formula: this.formulaHtmlContent.mean,
                },
                {
                    name: 'Коэффициент вариации',
                    content: {
                        firstAction: `${blockInfo.std.value} &times; 100 = ${blockInfo.varnum}`,
                        secondAction: blockInfo.var
                    },
                    formula:  this.formulaHtmlContent.varCoef
                },
                {
                    name: 'Среднее квадратичное отклонение',
                    content: {
                        firstAction: `${blockInfo.stdSumHtml} = ${blockInfo.stdnum}`,
                        secondAction: new SquareRoot(new Fraction(blockInfo.stdnum.render(), `(${blockInfo.count} − 1)`), blockInfo.std.value.render())
                    },
                    formula: this.formulaHtmlContent.std
                }
            ];

            const descriptionBlocksExport = descriptionBlocks.map(({name, content, formula}) => ({
                name,
                content: {
                    firstAction: content.firstAction.replace(/<sup>2<\/sup>/g, " ^2").replace(/<span>|<\/span>/g, ""), 
                    secondAction: content.secondAction.export
                }, 
                formula: formula.export.replace(/<sup>2<\/sup>/g, " ^2").replace(/<span>|<\/span>/g, "")
            }));
            
            let nmcHtml = blockInfo.isCorrect ? `<div class="description-block">
                <div class="name">${nmcBlock.name}</div>
                <div class="formula">${nmcBlock.formula}</div>
                <div class="content">${nmcBlock.content}</div>
            </div>` : "";

            this.nmcBlocks.push({
                name: nmcBlock.name,
                content: `${blockInfo.resultPriceHtml.export} = ${blockInfo.resultPrice}`,
                formula: this.formulaHtmlContent.nmc.export,
            });
            this.descriptionBlocks.push(descriptionBlocksExport);

            return nmcHtml + descriptionBlocks.map((block) => {
                return `<div class="description-block">
                    <div class="name">${block.name}</div>
                    <div class="formula">${block.formula.html}</div>
                    <div class="content"><ol><li>${block.content.firstAction}</li><li>${block.content.secondAction.html}</li></ol></div>
                </div>`;

            }).join("");
        };

        const renderInfoTable = (blockInfo, renderCoefError) => {
            const resultPrice = blockInfo.isCorrect? blockInfo.resultPrice.render(): "";
            const mean = blockInfo.mean.value.as(Unit.RUBLE).render();
            const varCoef = blockInfo.var.value.render();
            const std = blockInfo.std.value.render();
            this.mainTables.push({
                comment: blockInfo.comment, resultPrice, mean, varCoef, std, clear: {
                    count: blockInfo.values.length,
                    prices: blockInfo.values.map(v=>v.value),
                    std: blockInfo.std.value.value,
                    mean: blockInfo.mean.value.value,
                    var: blockInfo.var.value.value,
                    result: blockInfo.isCorrect ? blockInfo.resultPrice.value : ""
                }
            });
            if (blockInfo.isCorrect) {
                return `<table class="local-info-table">
                            <tr><td>НМЦК</td><td>${resultPrice}</td></tr>
                            <tr><td>Средняя цена</td><td>${mean}</td></tr>
                            <tr><td>Коэффициент вариации</td><td>${varCoef}</td></tr>
                            <tr><td>Среднее квадратичное отклонение</td><td>${std}</td></tr>
                        </table>`
            }

            if(renderCoefError) {
                return `<div class="toggle-content var-coef-error" data-rowIndex=${blockInfo.rowIndex}>
                            ${$(".coef-error").html()}
                        </div>`
            }

            return '';
        }

        const renderPrintedInfo = (blockInfo) =>{
            let calculateData = {
                countGoods: tools.getLocaleNumber(blockInfo.countGoods, {minPrecision: 0, maxPrecision: 6})
            };

            calculateData.detalization = blockInfo.printedInfo.map((block) => {
                return {
                    providerName: block.providerName || block.defaultValue,
                    providerPrice: tools.getLocaleSumInRubbles(block.providerPrice),
                    clearPrice: block.providerPrice,
                }
            });
            
            let result = `<div class="description-block calculated-data">
                <p>Расчётные данные</p><p>Количество товара – ${tools.getLocaleNumber(calculateData.countGoods, {minPrecision: 0, maxPrecision: 6})}</p>
                <p>Цена за единицу товара:</p>
            <table>`;
            result += calculateData.detalization.map((block) => {
                return `<tr>
                    <td>${block.providerName}</td>
                    <td>${block.providerPrice}</td>
                </tr>`
            }).join("");
            result+='</table></div>';
            
            this.calculatedData.push(calculateData);
            return result;
        }

        const renderCoefErrorSticky = (resultTable) => {
            const incorrectBlocksCount = resultTable.filter(block => !block.isCorrect).length;
            if(incorrectBlocksCount === 0)
            {
                return "";
            }
            return `<div class="toggle-content var-coef-error-sticky content-expanded">
                        <div class="title-header">
                            <div class="title-image-div">
                                <img src="images/0037-33per-large@1x.png" width="141px" srcset="images/0037-33per-large@3x.png 2x, images/0037-33per-large@3x.png 3x">
                            </div>
                            <div class="title">
                                Расчёт НМЦК не может быть произведён, <br />коэффициент вариации превышает 33%
                            </div>
                            <div class="title-arrow-div hidden-print">
                                <a id="titleArrowInput" class="title-arrow-input" style="display: inline;"></a>
                            </div>
                        </div>
                        <div class="description">
                            в соответствии с <a href="#" class="smart-link" data-link="req=doc&base=LAW&n=153376&dst=100116">п.3.20.2</a> Приказа Министерства экономического развития РФ от 2&nbsp;октября&nbsp;2013 г. № 567 совокупность значений, используемых в расчёте, при определении НМЦК считается неоднородной, если коэффициент вариации цены превышает 33%
                            <div>
                                ${resultTable.length > 1 ? 
                                    `<div class="coef-error-title">Позиции с превышением</div>
                                        ${resultTable.map(block => {
                                            if(!block.isCorrect) {
                                                return `<button class="coef-error-button" data-rowIndex=${block.rowIndex}>${block.comment ? block.comment : "позиция расчёта НМЦК"}</button>`;
                                            }
                                        }).join("")}` 
                                    : ''}
                            </div>
                        </div>
                    </div>`
        }

        this.addOutputField(".signle-result .result-content", "resultTable", {render: (resultTable) => {
                if (resultTable.length > 1)
                    return "";
                this.descriptionBlocks = [];
                this.mainTables = [];
                this.calculatedData = [];
                this.nmcBlocks = [];

                var resultDiv = document.createElement('div');
                resultDiv.innerHTML = renderCoefErrorSticky(resultTable) + resultTable.map(block => renderInfoTable(block, false) + renderDescriptionBlock(block) + renderPrintedInfo(block)).join("");
                return resultDiv;
            },  
            html:""
        });

        this.addOutputField(".several-results .result-content", "resultTable", {render: (resultTable) => {
            if (resultTable.length <= 1)
                return "";
            this.descriptionBlocks = [];
            this.mainTables = [];
            this.calculatedData = [];
            this.nmcBlocks = [];

            var resultDiv = document.createElement('div');
            resultDiv.innerHTML = renderCoefErrorSticky(resultTable) + resultTable.map(block => {
                let result = `<div class="comment">${block.comment}</div>
                                    ${renderInfoTable(block, true)}
                                    <div class="toggle-content toggle-description-blocks">
                                        <div class="description">
                                            ${renderDescriptionBlock(block)}
                                        </div>
                                    ${resultTable.length > 1 ? `<a role="button" class="exemption-link secondary" open-text="показать расчёт" close-text="свернуть расчёт">показать расчёт</a>`: ""}
                                </div>`;
                result += renderPrintedInfo(block);

                return result;
            }).join("");
            
            return resultDiv;
        },
        html:""
        });

        this.addOutputField(".signle-result", "resultTable", {
            type: "conditionalBlock",
            render: (x) => x.length == 1,
            alternativeBlock: ".several-results"
        });

        this.submitOnChange();
        this.loadDescription(false);
        this.addResetButton("#clearCalcInput");

        this.isDataDeleted = false;
		this.calculationsCountMax = 0;
        this.calculatedData = [];
    }

    downloadXlsxData() {
        function fetchXlsxSourceTitles(data) {
            let sources = [];
            let dublicates = false;
            const uniqueSources = [];
            for (let i = 0; i < data.calculatedData.length; i++) {
                const it = data.calculatedData[i];
                for (let j = 0; j < it.detalization.length; j++) {
                    const providerName = it.detalization[j].providerName;
                    if (uniqueSources.indexOf(providerName) < 0) {
                        uniqueSources.push(tools.unescapeTags(providerName));
                    }
                }
                if (it.detalization.length > sources.length) {
                    sources = it.detalization.map((_, i) => `Источник цены ${i + 1}`);
                }
                if (Array.from(new Set(it.detalization.map(d => d.providerName))).length < it.detalization.length)
                    dublicates = true;
            }
    
            if (!dublicates) {
                const uniqueConf = { empty: 0, filled: 0 };
                for (let i = 0; i < data.calculatedData.length; i++) {
                    const it = data.calculatedData[i];
                    const filled = it.detalization.length;
                    uniqueConf.filled += filled;
                    uniqueConf.empty += (uniqueSources.length - filled);
                }
    
                if (uniqueConf.empty < uniqueConf.filled) {
                    return uniqueSources;
                }
            }
    
            for (let i = 0; i < data.calculatedData.length; i++) {
                const it = data.calculatedData[i];
                for (let j = 0; j < it.detalization.length; j++) {
                    it.detalization[j].providerName = sources[j];
                }
            }
    
            return sources;
        }

        const data = this.generateExportObject();
        const sources = fetchXlsxSourceTitles(data);
        const rowShift = data.mainTables.length - 1;
        const overall = data.mainTables.map(mt => mt.clear.result || 0).reduce((acc, v) => acc + v, 0);
        const now = new Date();
        const z = (v) => (v < 10 ? '0' : '') + v;
        buildXlsx('/public/nmck-template.xlsx', {
            sources: sources.slice(2),
            source0: sources[0],
            source1: sources[1],
            spaces: sources.slice(2).map(s=>''),
            overall: overall,
            overall_rub: tools.verboseCountingValue(tools.getLocaleSum(overall), [['рубль', 'рубля', 'рублей']]),
            now: `${z(now.getDate())}.${z(now.getMonth() + 1)}.${now.getFullYear()}`,
            rows: data.mainTables.map((mt, index) => {
                const detalization = data.calculatedData[index].detalization;
                const src = sources.map(title => (detalization.filter(d => tools.unescapeTags(d.providerName) == title)[0] || { clearPrice: '—' }).clearPrice);
                return {
                    index: index + 1,
                    title: tools.unescapeTags(mt.comment),
                    src0: src[0], src1: src[1], src: src.slice(2),
                    okpd2: '',
                    unit: '',
                    nmck: mt.clear.result,
                    ...mt.clear,
                    count: tools.getLocaleNumber(data.calculatedData[index].countGoods, {minPrecision: 0, maxPrecision: 6})
                };
            }),
        }, 'Обоснование НМЦК.xlsx', {
            preproc: (template) => {
                if (sources.length > 3)
                    shiftWidth(template, 'J', sources.length - 3);
            },
            postproc: (template) => {
                const cnt = sources.length - 3;
                mergeCellsRight(template, [
                    { cell: 'A2', count: cnt }, { cell: 'C4', count: cnt }, { cell: 'C6', count: cnt },
                    { cell: 'A8', count: cnt }, { cell: 'A9', count: cnt }, { cell: `A${17+rowShift}`, count: cnt + 2 },
                    { cell: 'G12', count: cnt + 2}
                ]);
            }
        });
        this.sendStatisticMessage("justification_xlsx");
    }

    get defaultFilled() {
        return $("#nmccTable").find('.dynamic-list-row .edge-padding-with-button').length > 1;
    }

    render() {
        super.render();
        
        $(".exemption-link").click((e) => {
            let $description =  $(e.target).closest(".toggle-content").find(".description");
            if ($(e.target).hasClass("content-expanded")) {
                $(e.target).html($(e.target).attr("open-text"));
                $(e.target).removeClass("content-expanded");
                $description.fadeOut(300);
            } else {
                $(e.target).html($(e.target).attr("close-text"));
                $(e.target).addClass("content-expanded");
                $description.fadeIn(300);
            }
        });

        $(".var-coef-error-sticky .title-header").click((e) => {
            const $errorSticky = $(".var-coef-error-sticky");
            const $description =  $errorSticky.find(".description");
            const $arrow =  $errorSticky.find(".title-arrow-input");
            if ($errorSticky.hasClass("content-expanded")) {
                $errorSticky.removeClass("content-expanded");
                $description.fadeOut(300);
                $arrow.addClass('collapsed');
            } else {
                $errorSticky.addClass("content-expanded");
                $description.fadeIn(300);
                $arrow.removeClass('collapsed');
            }
        });

        $(".coef-error-button").click((e) => {
            const $target = $(e.target);
            const el = $(`.var-coef-error[data-rowindex='${$target.data('rowindex')}']`);
            $([document.documentElement, document.body]).animate({
                scrollTop: el.offset().top - 350
            }, 500);
        });

        document.addEventListener("scroll", () => {
            const $coefErrorSticky = $(".var-coef-error-sticky");
            const currentScroll = window.scrollY;
            if (currentScroll > 200) {
                if($coefErrorSticky.hasClass("content-expanded")) {
                    $(".var-coef-error-sticky .title-header").click();
                }
            } else {
                if(!$coefErrorSticky.hasClass("content-expanded")) {
                    $(".var-coef-error-sticky .title-header").click();
                }
            }
        });

        this.resultTable.forEach(b => {
            if (b.isCorrect) {
                $("#nmccTable").find(`.dynamic-list-row[data-rowindex=${b.rowIndex}] .title-image-div`).addClass('hidden-control');
            } else {
                $("#nmccTable").find(`.dynamic-list-row[data-rowindex=${b.rowIndex}] .title-image-div`).removeClass('hidden-control');
            }
        });

        if (this.resultTable.every(b => b.isCorrect))
        {
            $(".excel-export-container").removeClass("disabled");
        }
        else
        {
            $(".excel-export-container").addClass("disabled");
        }

        $(".smart-link").each(function() {
            tools.initSmartLink(this);
        })
    }

    onReset() {
        this.onResetCommon();
        $(".providers").show();
        $("#nmccTable").find(`.dynamic-list-row .title-image-div`).addClass('hidden-control');
    }

    onResetCommon() {
        const blockPiece = this.dynamicCalculation.getElements()[0];
        blockPiece.tree.providersData.setCount({count: 3});
        this.isDataDeleted = true;
    }

    generateExportObject() {
        let result = super.generateExportObject();
        result.descriptionsBlock = this.descriptionBlocks;
        result.nmcBlocks = this.nmcBlocks;
        result.mainTables = this.mainTables;
        result.calculatedData = this.calculatedData;
        result.render.isAllCorrect = this.isAllCorrect;
        result.render.coefError = tools.convertElemToTextWithLinksForExport($(".coef-error .description")[0])
        return result;
    }

    renderError() {
        $(".export-result, .main-block").addClass("disabled");
        $(".results").hide();
    }

    beforeSubmit() {
        $(".calc-div-results").removeClass("empty");
        $(".export-result, .main-block").removeClass("disabled");
        $(".results").show();
    }

    calculate() {
        this.isAllCorrect = true;
        this.calculatedList = this.calculatedList || [];
        this.resultTable = this.calculatedList
        .filter((block) => (block.providersData || []).length >= 3 && block.countGoods && block.providersData.filter(block => !block.providerPrice).length == 0)
        .map((block) => {
            const bullet = calculationBullet(block.providersData.map((block) => block.providerPrice));
            const countGoods = block.countGoods;
            const isCorrect = bullet.var.v <= 33;
            this.isAllCorrect = this.isAllCorrect && isCorrect;

            if (this.calculatedData.length > this.calculationsCountMax || this.isDataDeleted) {
                this.calculationsCountMax = this.calculatedData.length;
                this.sendStatisticMessage("Is_Made");
                this.isDataDeleted = false;
            }

            return {
                printedInfo: block.providersData,
                isCorrect: isCorrect,
                resultPriceHtml: new Fraction(`${tools.getLocaleNumber(countGoods, {minPrecision: 0, maxPrecision: 6})} &times; (${bullet.values.map(v => v.render()).join("&nbsp;+&nbsp;")})`, new UnitProp(bullet.values.length, Unit.COUNT)),
                resultPrice: new UnitProp(bullet.values.reduce((acc, v) => acc + v.value, 0) * countGoods / bullet.values.length, Unit.RUBLE),
                elementsSumHtml: bullet.values.map(v => v.render()).join("&nbsp;+&nbsp;"),
                stdSumHtml: bullet.values.map(v => (
                    `<span>(${v} − ${bullet.mean.value.as(Unit.SUM)})<sup>2</sup></span>`
                )).join("&nbsp;+&nbsp;"),
                comment: block.comment,
                rowIndex: block.rowIndex,
                countGoods,
                ...bullet
            };
        });

        this.resultPrice =  this.resultTable.reduce((a, b) => a + b.resultPrice.value, 0);
        return this.resultTable.length;
    }
}

class NmccTextField extends TextField {
    static keyName() { return "nmccText"; }
    isFilled() { return this.getClearValue() !== this.defaultValue() || this.defaultValue() == null; }
    reset() { this.setValue(this.defaultValue());}
}

$(function () {
    var calc = new NmcCalculator();
});
